import React, { useState, useEffect } from 'react';

import { observer } from 'mobx-react';
import { useMst } from '../../store/store';
import Swal from 'sweetalert2';
import './PageStaking.scss';

const LPStaking: React.FC = observer(() => {
  const { user } = useMst();
  const [flexAmount, setFlexAmount] = useState('0');
  const [poolId, setPoolId] = useState('0');
  const [getApproveBalance, setApproveBalance] = useState('0');
  const [getApproveAmt, setApproveAmt] = useState('0');
  const [poolDetails, setPoolData] = useState<poolObj[]>([]);
  const [getTotalStakeAmt, setTotalStakeAmt] = useState(0);
  // const [getTotalHarvestAmt, setTotalHarvestAmt] = useState('0');

  // const [userStakeData, setUserStakeData] = useState<obj[]>([]);

  const token_address = "TLvFUBRS5f57tFb5izyAQ9BV5CsWBmqDRX";
  // const token_address = "TX3DqZZqftCaKQBrkZMiJxWfeRsg9mYJ2Z";

  // interface obj {
  //   stakeTime: any;
  //   unStakeTime: any;
  //   stakeAmount: any;
  //   poolId: any;
  //   pool_id: any
  //   rewards: any;
  //   stakeId: any;
  //   decimal: any;
  //   Action: any;
  // }

  interface poolObj {
    id: any;
    name: any;
  }
  // const data: any[] = [];
  const poolData: any[] = [];

  async function getInfo(pool_id) {
    console.log(pool_id);
    const token_instance = await window.tronWeb.contract().at(token_address);
    const poolInfo = await token_instance.methods.pool(pool_id).call();
    const tokenAddress = window.tronWeb.address.fromHex(poolInfo.tokenAddress);
    const pool_token_instance = await window.tronWeb.contract().at(tokenAddress);
    return pool_token_instance;
  }

  const getbalance = async () => {
    const pool_id = Number(poolId);

    // const token_instance = await window.tronWeb.contract().at(token_address);
    if (pool_id > 0) {
      const pool_token_instance = await getInfo(pool_id);
      const hex_balance = await pool_token_instance.methods.balanceOf(user.address).call();
      const hex_allowance = await pool_token_instance.methods.allowance(user.address, token_address).call();
      const allowance = await window.tronWeb.toDecimal(hex_allowance);
      const balance = await window.tronWeb.toDecimal(hex_balance);
      const decimal = await pool_token_instance.decimals().call();
      const setallowance = allowance / 10 ** decimal;
      const token_bal = balance / 10 ** decimal;
      console.log("token_bal", token_bal);
      setApproveBalance(token_bal.toString());
      setApproveAmt(setallowance.toString());

    }
  }
  getbalance();

  const approveFun = async () => {
    // const pool_token_instance = await window.tronWeb.contract().at("TP6NLpCWJSeC5zBDf846ReckHbFgsbJk1y");
    // const pool_token_instance = await getInfo(0, token_instance);
    // const approveCall = await pool_token_instance.methods.approve(token_address, (1 * 10 ** 8).toString()).send();
    // console.log(approveCall);
    if (user.address === "") {
      Swal.fire({ title: "<h5 style='color:white'>Connect your wallet</h5>", icon: "warning", background: "#808080", showConfirmButton: false, timer: 3000 });
    } else {
      const amount = Number(flexAmount);
      const pool_id = Number(poolId);
      if (pool_id <= 0) {
        // console.log(pool_id);
        Swal.fire({ title: "<h5 style='color:white'>Select the pool</h5>", icon: "warning", background: "#808080", showConfirmButton: false, timer: 3000 });
      } else if (amount <= 0) {
        Swal.fire({ title: "<h5 style='color:white'>Not a valid amount</h5>", icon: "warning", background: "#808080", showConfirmButton: false, timer: 3000 });
      } else {
        // const token_instance = await window.tronWeb.contract().at(token_address);
        const pool_token_instance = await getInfo(pool_id);
        console.log("pool_token_instance", pool_token_instance);
        const decimal = await pool_token_instance.methods.decimals().call();
        const hex_balance = await pool_token_instance.methods.balanceOf(user.address).call();
        const balance = await window.tronWeb.toDecimal(hex_balance);
        if (balance <= 0) {
          Swal.fire({ title: "<h5 style='color:white'>Not sufficient tokens in your account.</h5>", icon: "warning", background: "#808080", showConfirmButton: false, timer: 3000 });
        }
        else {
          const approveCall = await pool_token_instance.methods.approve(token_address, (amount * 10 ** decimal).toString()).send();
          // console.log("approveCall", approveCall);
          Swal.fire({ title: "<h5 style='color:white'>Transaction sent! Wait for confirmation.</h5>", icon: "success", background: "#808080", showConfirmButton: false, timer: 3000 });
          setTimeout(async function () {
            const event = await window.tronWeb.trx.getUnconfirmedTransactionInfo(approveCall);
            console.log(event);
            if (event.receipt.result === 'SUCCESS') {
              Swal.fire({ title: "<h5 style='color:white'>Transaction confirmed.</h5>", icon: "success", background: "#808080", showConfirmButton: false, timer: 4000 });
              setFlexAmount("0");
              getbalance();
            } else {
              Swal.fire({ title: "<h5 style='color:white'>Transaction failed.</h5>", icon: "error", background: "#808080", showConfirmButton: false, timer: 4000 });
            }
          }, 9000);
        }
      }
    }


  }


  // const userstakeDetails = async (i, token_instance) => {
  //   return new Promise((resolve) => {
  //     const obj = {
  //       stakeTime: '',
  //       unStakeTime: '',
  //       stakeAmount: '',
  //       poolId: '',
  //       pool_id: '',
  //       rewards: '',
  //       stakeId: '',
  //       decimal: '',
  //     };
  //     token_instance.methods.stakeDetails(user.address, i).call().then(async (stake_details) => {
  //       const stakeAmount = window.tronWeb.toDecimal(stake_details.amount);
  //       const stakeTime = window.tronWeb.toDecimal(stake_details.stackTime);
  //       const unstakeTime = window.tronWeb.toDecimal(stake_details.unstakeTime);
  //       const pool = window.tronWeb.toDecimal(stake_details.poolId);
  //       const poolInfo = await token_instance.methods.pool(pool).call();
  //       const tokenAddress = window.tronWeb.address.fromHex(poolInfo.tokenAddress);
  //       const pool_token_instance = await window.tronWeb.contract().at(tokenAddress);
  //       const decimal = await pool_token_instance.methods.decimals().call();
  //       const poolName = await pool_token_instance.methods.name().call();
  //       token_instance.methods.getCurrentReward(user.address, i).call().then((reward) => {
  //         const rewards = window.tronWeb.toDecimal(reward);
  //         obj.stakeTime = stakeTime;
  //         obj.unStakeTime = unstakeTime;
  //         obj.stakeAmount = stakeAmount;
  //         obj.poolId = poolName;
  //         obj.pool_id = pool;
  //         obj.rewards = rewards;
  //         obj.stakeId = i;
  //         obj.decimal = decimal;

  //         resolve(data.push(obj));
  //       });
  //     })
  //   })
  // }

  // const getstakeDetails = async () => {
  //   const token_instance = await window.tronWeb.contract().at(token_address);
  //   const stake_length = await token_instance.methods.getStakeLength(user.address).call();
  //   const length = window.tronWeb.toDecimal(stake_length);
  //   let i = 0;
  //   /* eslint-disable no-await-in-loop */
  //   while (i < length) {
  //     await userstakeDetails(i, token_instance);
  //     i += 1;
  //   }
  //   setUserStakeData(data);
  // }

  //  getstakeDetails();
  // setInterval(getstakeDetails, 10000);

  const stakeFun = async () => {

    if (user.address === "") {
      Swal.fire({ title: "<h5 style='color:white'>Connect your wallet.</h5>", icon: "warning", background: "#808080", showConfirmButton: false, timer: 3000 });
    } else {
      const amount = Number(flexAmount);
      const pool_id = Number(poolId);
      if (pool_id <= 0) {
        Swal.fire({ title: "<h5 style='color:white'>Select the pool</h5>", icon: "warning", background: "#808080", showConfirmButton: false, timer: 3000 });
      }
      else if (amount <= 0) {
        Swal.fire({ title: "<h5 style='color:white'>Not a valid amount</h5>", icon: "warning", background: "#808080", showConfirmButton: false, timer: 3000 });
      }
      else {
        const token_instance = await window.tronWeb.contract().at(token_address);
        const pool_token_instance = await getInfo(pool_id);
        const hex_allowance = await pool_token_instance.methods.allowance(user.address, token_address).call();
        const allowance = await window.tronWeb.toDecimal(hex_allowance);
        const decimal = await pool_token_instance.decimals().call();
        if (allowance < amount * 10 ** decimal) {
          Swal.fire({ title: "<h5 style='color:white'>Not enough approve tokens.</h5>", icon: "warning", background: "#808080", showConfirmButton: false, timer: 3000 });
        }
        else {
          const staked = await token_instance.methods.staking((amount * 10 ** decimal).toString(), pool_id - 1).send();
          Swal.fire({ title: "<h5 style='color:white'>Transaction sent! Wait for confirmation.</h5>", icon: "success", background: "#808080", showConfirmButton: false, timer: 3000 });
          setTimeout(async function () {
            const event = await window.tronWeb.trx.getUnconfirmedTransactionInfo(staked);
            console.log(event);
            if (event.receipt.result === 'SUCCESS') {
              Swal.fire({ title: "<h5 style='color:white'>Transaction confirmed.</h5>", icon: "success", background: "#808080", showConfirmButton: false, timer: 4000 });
              setFlexAmount("0");
              // document.getElementById("tokenbalance").innerHTML = (amount).toString();
              // getstakeDetails();
              getbalance();
            } else {
              Swal.fire({ title: "<h5 style='color:white'>Transaction failed.</h5>", icon: "error", background: "#808080", showConfirmButton: false, timer: 4000 });
            }
          }, 9000);
        }
      }
    }
  }

  const getPool = async (token_instance, i) => {
    return new Promise((resolve) => {
      const poolObj = {
        id: '',
        name: '',
      };
      token_instance.methods.pool(i).call().then(async (poolInfo) => {
        // console.log("poolInfo", poolInfo);
        const poolAddress = window.tronWeb.address.fromHex(poolInfo.tokenAddress);
        const tokenInstance = await window.tronWeb.contract().at(poolAddress);
        const Name = await tokenInstance.methods.name().call();
        // console.log("name", Name);
        poolObj.id = i;
        poolObj.name = Name;
        resolve(poolData.push(poolObj));


      });
    });
  }
  const pools = async () => {
    const token_instance = await window.tronWeb.contract().at(token_address);
    const pool_length = await token_instance.methods.poolLength().call();
    let i = 0;
    /* eslint-disable no-await-in-loop */
    while (i < pool_length) {
      const hex_status = await token_instance.methods.pool(i).call();
      if (hex_status !== true) {
        await getPool(token_instance, i);
      }
      i += 1;
    }
    setPoolData(poolData);
  }
  pools();

  const unstakeFun = async () => {
    if (user.address === "") {
      Swal.fire({ title: "<h5 style='color:white'>Connect your wallet.</h5>", icon: "warning", background: "#808080", showConfirmButton: false, timer: 3000 });
    } else {
      const token_instance = await window.tronWeb.contract().at(token_address);
      // console.log(token_instance);
      // const pool_status = await token_instance.methods.poolStatus(pool_id).call();
      const emergercyStatus = await token_instance.methods.viewEmergencyWithdrawalStatus().call();
      if (emergercyStatus === true) {
        const unstake_token = await token_instance.methods.unstaking().send();
        Swal.fire({ title: "<h5 style='color:white'>Transaction sent! Wait for confirmation.</h5>", icon: "success", background: "#808080", showConfirmButton: false, timer: 3000 });
        setTimeout(async function () {
          const event = await window.tronWeb.trx.getUnconfirmedTransactionInfo(unstake_token);
          if (event.receipt.result === 'SUCCESS') {
            // getstakeDetails();
            getbalance();
            Swal.fire({ title: "<h5 style='color:white'>Transaction confirmed.</h5>", icon: "success", background: "#808080", showConfirmButton: false, timer: 4000 });
          } else {
            // console.log(event.receipt.result)
            Swal.fire({ title: "<h5 style='color:white'>Transaction failed.</h5>", icon: "error", background: "#808080", showConfirmButton: false, timer: 4000 });
          }
        }, 9000);
      } else {
        const getStakeAmount = async () => {
          const token_instances = await window.tronWeb.contract().at(token_address);
          const userDetails = await token_instance.methods.viewUserStakingIds("TE2Ejmie6ofD24GWEtUX8ugkLbdXSKZxQX").call();
          console.log(userDetails);
          let i = 0;
          // const unStakerequests: any[] = [];
          while(i < userDetails.length) {
            const stakingDetails = await token_instances.methods.stakeDetails(userDetails[i]).call();
            console.log("stakingDetails", stakingDetails);
            const unstakeTime = await window.tronWeb.toDecimal(stakingDetails.unstakeTime);
            console.log("unstakeTime",unstakeTime);
            if(unstakeTime > 0 ){
              const unstake_token = await token_instance.methods.unstaking(stakingDetails).send();
              console.log(unstake_token);
            }    
            // else {
              
            //   unStakerequests.push(stakingDetails);
            //   console.log("unStakerequests", unStakerequests);

            //   if(unStakerequests > 0) {}

                              
            // }
            i += 1;
      }
    }
    console.log(getStakeAmount);
  }
}
}


  const harvestFun = async () => {
    if (user.address === "") {
      Swal.fire({ title: "<h5 style='color:white'>Connect your wallet.</h5>", icon: "warning", background: "#808080", showConfirmButton: false, timer: 3000 });
    } else {
      const token_instance = await window.tronWeb.contract().at(token_address);
      console.log("token_instance", token_instance)
      const harvest_token = await token_instance.methods.harvest().send({from:user.Address});
      console.log(harvest_token);
      Swal.fire({ title: "<h5 style='color:white'>Transaction sent! Wait for confirmation.</h5>", icon: "success", background: "#808080", showConfirmButton: false, timer: 3000 });
      setTimeout(async function () {
        const event = await window.tronWeb.trx.getUnconfirmedTransactionInfo(harvest_token);
        if (event.receipt.result === 'SUCCESS') {
          Swal.fire({ title: "<h5 style='color:white'>Transaction confirmed.</h5>", icon: "success", background: "#808080", showConfirmButton: false, timer: 4000 });
        } else {
          Swal.fire({ title: "<h5 style='color:white'>Transaction failed.</h5>", icon: "error", background: "#808080", showConfirmButton: false, timer: 4000 });
        }
      }, 9000);
    }
  }

  useEffect(() => {
    const getStakeAmount = async () => {
      const token_instance = await window.tronWeb.contract().at(token_address);
      const userDetails = await token_instance.methods.viewUserStakingIds("TE2Ejmie6ofD24GWEtUX8ugkLbdXSKZxQX").call();
      console.log(userDetails);
      let i = 0;
      let tuserStakeAmount = 0;
      while(i < userDetails.length) {
        const stakingDetails = await token_instance.methods.stakeDetails(userDetails[i]).call();
        // console.log("stakingDetails", stakingDetails);
        const unstakeTime = await window.tronWeb.toDecimal(stakingDetails.unstakeTime);
        console.log("unstakeTime",unstakeTime);
        const stakeAmount = await window.tronWeb.toDecimal(stakingDetails.amount);
        const PoolsId = await window.tronWeb.toDecimal(stakingDetails.poolId);
         console.log("Stake", stakeAmount);
         console.log("poolId", PoolsId); 
         const pool_token_instance = await getInfo(PoolsId);
         console.log("pool_token_instance", pool_token_instance);
         const decimal = await pool_token_instance.decimals().call();
         console.log("decimal", decimal, stakeAmount);
         tuserStakeAmount += stakeAmount/10**decimal;
         console.log("stakeAmount", stakeAmount);
         i += 1;
         console.log("tuserStakeAmount", tuserStakeAmount);
      }
    console.log("tuserStakeAmount", tuserStakeAmount);

      
      // console.log(user.address);
      // console.log(userDeatails.length, "userDeatils");

      // const tstakeAmt = await window.tronWeb.toDecimal(userDeatails.totalStakeAmount);
      // console.log(tstakeAmt);
      setTotalStakeAmt(tuserStakeAmount);
      // const tharvestAmt = await window.tronWeb.toDecimal(userDeatails.totalHarvestAmount);
      // console.log(tharvestAmt);
      // setTotalHarvestAmt(tharvestAmt);
    }
    // getStakeAmount();
    if (user.address) {
      getStakeAmount();
    }
  }, [user.address])

  return (
    <>





      {/* <Tab eventKey="home" title="LP Staking"> */}
      <div className='staking__tabs' >
        <div className='text-center'>
          <h3>Staking </h3>
          <p >Token Balance: <span id="tokenbalance">{getApproveBalance}</span> SM</p>
          <p >Approve Balance: <span id="approvebalance">{getApproveAmt}</span> SM</p>
          <div className="custom-select w-60" >
            <select className='w-100 border-0' onChange={(e) => { setPoolId(e.target.value) }} >
              <option>Select Coin</option>
              {
                poolDetails.map((item) => {
                  return (
                    <option value={item.id + 1} id='pools' key={item.id + 1}>{item.name}</option>
                  )
                })
              }
            </select>
          </div>
        </div>
        <div className='staking_amount mb-4 mt-2 d-flex justify-content-center' style={{ alignItems: "center", gap: "20px" }}>
          <div className='text-center' style={{ width: "100%", border: "1px solid #fff", padding: "20px 25px 0", borderRadius: "15px" }}>

            <p  >Enter amount (SM):-</p>
            <input className='form-input' type="number" onChange={(e) => { setFlexAmount(e.target.value) }} name='username' value={flexAmount} id="hideamt" />
            <span id="amt_err" />
            <div className='text-center' style={{ display: 'flex', justifyContent: 'center' }}>
              <button className="liquidity-set__create yellow-btn" type='button' id="approve" onClick={approveFun}>Approve</button>
              <button className="liquidity-set__create yellow-btn" type='button' id="approve" onClick={stakeFun}>Stake</button>
              <button className="liquidity-set__create yellow-btn" type='button' id="approve" onClick={unstakeFun}>Unstake</button>
              <button className="liquidity-set__create yellow-btn" type='button' id="approve" onClick={harvestFun}>Harvest</button>



            </div>

          </div>

          <div id="hidetextstake" style={{ display: "none", border: "1px solid #e5ac4b", padding: "20px 25px 0", borderRadius: "15px" }}>
            <p>Enter amount (SM):-</p>
            <input className='form-input' type="number" name='username' placeholder='Enter your Amount' id="hideamt1" />
            <span id="amt_err" />
            <button className="liquidity-set__create yellow-btn" type='button' id="stake" >Stake</button>
            {/* <button className="liquidity-set__create yellow-btn" type='button' id="stake" style={{display:"none"}}>Stake</button> */}
          </div>
        </div>

        <div className='text-center' >

          <p >Total Staking Amount: <span id="tokenbalance">{getTotalStakeAmt}</span> SM</p>
          {/* <p >Total Harvested Amount: <span id="approvebalance">{getTotalHarvestAmt}</span> SM</p> */}

        </div>

        {/* <div className='staking_table'>
                      <h3 style={{ textAlign: 'center' }}>Your stats</h3>
                      <div className='tabless' style={{ overflow: "scroll", maxHeight: "400px" }}> */}
        {/* <table className="table"> */}
        {/* <thead>
                            <tr>
                              <th scope="col">StakeAmount</th>
                              <th scope="col">StakeTime</th>
                              <th scope="col">UnstakeTime</th>
                              <th scope="col">Pool</th>
                              <th scope="col">Rewards</th>
                              <th scope="col" style={{ textAlign: "center" }}>Unstack</th>
                              <th scope="col" style={{ textAlign: "center" }}>Claim</th>
                            </tr>
                          </thead> */}
        {/* <tbody id="received">
                            {
                              userStakeData.length > 0? userStakeData.map((item) => {
                                return (
                                  <tr key={item.stakeTime}>
                                    <td>{((item.stakeAmount) / 10 ** item.decimal)} SM</td>
                                    <td>{new Date(item.stakeTime * 1000).toLocaleString()}</td>
                                    <td>{item.unStakeTime !== 0 ? new Date(item.unStakeTime * 1000).toLocaleString() : 0}</td>
                                    <td>{(item.poolId)}</td>
                                    <td>{(item.rewards / 10 ** item.decimal)} SM</td>
                                    <td><button className="liquidity-set__create yellow-btn" type='button' id="unstake" onClick={() => unstake(item.stakeId, item.unStakeTime, item.pool_id)}>Unstack</button></td>
                                    <td><button className="liquidity-set__create yellow-btn" type='button' id="harvest" onClick={() => harvest(item.stakeId, item.pool_id)}>claim</button></td>
                                  </tr>
                                )
                              }):<tr><td colSpan={5}>No Stake Details Found.</td></tr>
                            }
                          </tbody> */}
        {/* </table> */}
        {/* </div>
                    </div> */}
      </div>
      {/* </Tab> */}

    </>
  );
});

export default LPStaking;
